module.exports = __webpack_public_path__ + "img/hot-dog.b01c316e.png";